import React, {useState} from 'react'
import Icon from '@/Shared/Icon';
import { useProps } from '@/Shared/FuncComp';
import { Dropdown } from 'react-bootstrap';
import Link from '@/Shared/Link';

export default ({className, ...props}) => {
	className = "relative text-dark"+(className?" "+className:"");
	const { auth } = useProps();
	const [menuOpened, setMenuOpened] = useState(false);
	return <div className={className} {...props}>
		<div
			className="flex items-center cursor-pointer select-none group"
			onClick={() => setMenuOpened(true)}
		>
			<div className="text-gray-800 group-hover:text-indigo-600 focus:text-indigo-600 mr-1 whitespace-no-wrap">
				<span>{auth.user.first_name}</span>
				<span className="ml-1 hidden md:inline">{auth.user.last_name}</span>
			</div>
			<Icon
				className="w-5 h-5 fill-current text-gray-800 group-hover:text-indigo-600 focus:text-indigo-600"
				name="cheveron-down"
			/>
		</div>
		<div className={menuOpened ? '' : 'hidden'}>
			<div className="whitespace-no-wrap absolute z-20 mt-8 left-auto top-0 right-0 py-2 shadow-xl bg-white rounded text-sm">
				<Link
					href={route('intranet.cotizaciones.index')}
					className="block px-6 py-2 hover:bg-indigo-600 hover:text-white"
				>
					Cotizaciones
				</Link>
				<Link
					href={route('dashboard')}
					className="block px-6 py-2 hover:bg-indigo-600 hover:text-white"
				>
					Dashboard
				</Link>
				<Dropdown.Divider />
				<Link
					href={route('users.edit', auth.user.id)}
					className="block px-6 py-2 hover:bg-indigo-600 hover:text-white"
				>
					Mi perfil
				</Link>
				<Link
					href={route('users')}
					className="block px-6 py-2 hover:bg-indigo-600 hover:text-white"
				>
					Administrar usuarios
				</Link>

				<Dropdown.Divider />
				<Link
					linkAs="button"
					href={route('logout')}
					className="block px-6 py-2 hover:bg-indigo-600 hover:text-white w-100"
					method="post"
				>
					Cerrar sesión
				</Link>
			</div>
			<div
				onClick={() => {
					setMenuOpened(false);
				}}
				className="bg-black opacity-25 fixed inset-0 z-10"
			></div>
		</div>
	</div>
}
